import { render, staticRenderFns } from "./PaymentFactoryView.vue?vue&type=template&id=115a40c4&scoped=true&"
import script from "./PaymentFactoryView.vue?vue&type=script&lang=js&"
export * from "./PaymentFactoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115a40c4",
  null
  
)

export default component.exports